<template>
    <div class="index" v-cloak>
        <div class="search-wrap flex">
            <a @click="goSearch" class="search-link"
                >输入股票代码/首字母查询个股详情</a
            >
            <a @click="goHome" class="link-btn">全市场</a>
        </div>
        <div
            v-if="
                (codeType === 'SH' || codeType === 'SZ') &&
                !notData &&
                queryShow
            "
        >
            <section class="mod mod2">
                <dl class="mod-top">
                    <dt>
                        {{ stockInform.stockName
                        }}<small>{{ stockInform.stockCode }}</small>
                    </dt>
                    <dd>
                        <span :class="stockInform.value | formateRedGreen">{{
                            stockInform.value
                        }}</span
                        ><span :class="stockInform.rate | formateRedGreen"
                            >{{ stockInform.rate | formatePrefixData }}%</span
                        >
                    </dd>
                </dl>
                <a class="link-more link-text-r" @click="gogufs">查看详情</a>
                <div
                    class="chart-info flex"
                    v-if="codeType === 'SH' || codeType === 'SZ'"
                >
                    <div>
                        持仓市值<strong :class="ccsz | formateRedGreen">{{
                            ccsz | process(2, false, "亿")
                        }}</strong>
                    </div>
                    <div>
                        持股量<strong>{{ cgsl }}万</strong>
                    </div>
                    <div>
                        持股占流通比<strong>{{ cglt }}%</strong>
                    </div>
                    <!-- <div>净买额<strong :class="jml | formateRedGreen">{{ jml | process(2, false, "万") }}</strong></div> -->
                </div>
                <div class="time-info" style="text-align: right">
                    数据日期: {{ dataTime }}
                </div>
            </section>

            <section class="mod">
                <div class="nav-sub-cont">
                    <!-- <div class="chart-legent" style="display:flex;align-items: center;justify-content: space-between;width:6.02rem">
            <span class="legent-rect legent">北向资金线<i class="tips" @click="bxggcjtjHelpShow = true"></i></span>
            <span class="fr" style="">日K</span>
          </div> -->
                    <div
                        id="klineChart"
                        class="chart chart-history klinebox"
                    ></div>
                </div>
            </section>

            <section class="mod">
                <h2 class="mod-tit mod-tit-block">
                    {{ stockInform.stockName }}({{
                        stockInform.stockCode
                    }})-港资机构持股
                    <div
                        class="fr link-more"
                        @click="goMore"
                        v-if="organizationList.length > 0"
                    >
                        查看更多
                    </div>
                </h2>
                <div
                    class="table-scroll table-organization"
                    v-if="organizationList.length > 0"
                >
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th width="50%">机构名称</th>
                            <!-- <th width="15%" style="text-align: center">详情</th> -->
                            <th width="25%">持股市值(元)</th>
                            <th width="25%">持股量</th>
                        </tr>
                        <tr
                            v-for="(item, index) in organizationList.slice(
                                0,
                                10
                            )"
                            :key="item.id"
                        >
                            <td colspan="4">
                                <div class="td-data">
                                    <div>
                                        <div
                                            class="name-l"
                                            @click="goJiGaoDetail(item)"
                                        >
                                            {{ item.compname }}
                                        </div>
                                    </div>
                                    <!-- <div>
                                        <span
                                            class="btn-toggle"
                                            @click="
                                                jiGouEchartsShow(index, item)
                                            "
                                            :class="item.showMore ? 'up' : ''"
                                            >{{
                                                item.showMore ? "收起" : "展开"
                                            }}</span
                                        >
                                    </div> -->
                                    <div>
                                        {{
                                            item.holdamt
                                                | process(2, false, "元")
                                        }}
                                    </div>
                                    <div>
                                        {{
                                            item.holdvol | process(2, false, "")
                                        }}
                                    </div>
                                </div>
                                <div class="td-more" v-show="item.showMore">
                                    <router-link
                                        :to="
                                            '/jgchartdetail?code=' +
                                            item.particode +
                                            '&stockCode=' +
                                            stockCode +
                                            '&name=' +
                                            item.compname
                                        "
                                        ><div class="chart-tr"></div
                                    ></router-link>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div
                    style="
                        height: 1.5rem;
                        text-align: center;
                        line-height: 1.5rem;
                        font-size: 14px;
                        color: #999999;
                    "
                    v-if="organizationList.length == 0"
                >
                    -暂无数据-
                </div>
            </section>

            <section class="mod">
                <h2 class="mod-tit">
                    {{ stockInform.stockName }}({{
                        stockInform.stockCode
                    }})持股变动<router-link
                        class="fr link-more"
                        :to="'/ggMore?id=1&code=' + stockCode"
                        v-if="cgbdData.length > 0"
                        >查看更多</router-link
                    >
                </h2>
                <div class="table-scroll" v-if="cgbdData.length > 0">
                    <div class="table-l fl">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>日期</th>
                            </tr>
                            <tr
                                v-for="item in cgbdData.slice(0, 5)"
                                :key="item.id"
                            >
                                <td>{{ item.TRADEDATE }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="table-r">
                        <div class="table-r-wrap">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tr>
                                    <th>收盘价</th>
                                    <th>涨跌幅</th>
                                    <th>北向资金持股量</th>
                                </tr>
                                <tr
                                    v-for="item in cgbdData.slice(0, 5)"
                                    :key="item.id"
                                >
                                    <td :class="item.TCLOSE">
                                        {{ item.TCLOSE }}
                                    </td>
                                    <td :class="item.PCHG | formateRedGreen">
                                        {{ item.PCHG }}%
                                    </td>
                                    <td :class="item.SHHKSHAREHOLD">
                                        {{
                                            item.SHHKSHAREHOLD
                                                | process(2, false, "")
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        height: 1.5rem;
                        text-align: center;
                        line-height: 1.5rem;
                        font-size: 14px;
                        color: #999999;
                    "
                    v-if="cgbdData.length == 0"
                >
                    -暂无数据-
                </div>
            </section>

            <section class="mod">
                <h2 class="mod-tit" v-if="historyNorthData.length > 0">
                    {{ stockInform.stockName }}({{
                        stockInform.stockCode
                    }})港股通成交榜<router-link
                        class="fr link-more"
                        :to="'/ggMore?id=2&code=' + stockCode"
                        v-if="historyNorthData.length > 0"
                        >查看更多</router-link
                    >
                </h2>
                <div class="table-scroll" v-if="historyNorthData.length > 0">
                    <div class="table-l fl">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>上榜日期</th>
                            </tr>
                            <tr
                                v-for="item in historyNorthData.slice(0, 5)"
                                :key="item.id"
                            >
                                <td>{{ item.TRADEDATE }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="table-r">
                        <div class="table-r-wrap">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tr>
                                    <th>排名</th>
                                    <th>收盘价</th>
                                    <th>涨跌幅</th>
                                    <th>成交额</th>
                                </tr>
                                <tr
                                    v-for="item in historyNorthData.slice(0, 5)"
                                    :key="item.id"
                                >
                                    <td :class="item.RANK">{{ item.RANK }}</td>
                                    <td :class="item.TCLOSE">
                                        {{ item.TCLOSE }}
                                    </td>
                                    <td :class="item.PCHG | formateRedGreen">
                                        {{ item.PCHG }}%
                                    </td>
                                    <td :class="item.TOTALAMT">
                                        {{
                                            item.TOTALAMT
                                                | process(2, false, "元")
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        height: 1.5rem;
                        text-align: center;
                        line-height: 1.5rem;
                        font-size: 14px;
                        color: #999999;
                    "
                    v-if="historyNorthData.length == 0"
                >
                    -暂无数据-
                </div>
            </section>
        </div>
        <div v-if="codeType !== 'SH' && codeType !== 'SZ'">
            <section class="mod">
                <h2 class="mod-tit" v-if="historyNorthData.length > 0">
                    {{ stockInform.stockName }}({{
                        stockInform.stockCode
                    }})港股通成交榜<router-link
                        class="fr link-more"
                        :to="'/ggMore?id=2&code=' + stockCode"
                        v-if="historyNorthData.length > 0"
                        >查看更多</router-link
                    >
                </h2>
                <div class="table-scroll" v-if="historyNorthData.length > 0">
                    <div class="table-l fl">
                        <table width="100%" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>上榜日期</th>
                            </tr>
                            <tr
                                v-for="item in historyNorthData.slice(0, 10)"
                                :key="item.id"
                            >
                                <td>{{ item.TRADEDATE }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="table-r">
                        <div class="table-r-wrap">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tr>
                                    <th>排名</th>
                                    <th>收盘价</th>
                                    <th>涨跌幅</th>
                                    <th>净流入</th>
                                </tr>
                                <tr
                                    v-for="item in historyNorthData.slice(
                                        0,
                                        10
                                    )"
                                    :key="item.id"
                                >
                                    <td :class="item.RANK">{{ item.RANK }}</td>
                                    <td :class="item.TCLOSE">
                                        {{ item.TCLOSE }}
                                    </td>
                                    <td :class="item.PCHG | formateRedGreen">
                                        {{ item.PCHG }}%
                                    </td>
                                    <td :class="item.DIFFAMT">
                                        {{
                                            item.DIFFAMT
                                                | process(2, false, "元")
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        height: 1.5rem;
                        text-align: center;
                        line-height: 1.5rem;
                        font-size: 14px;
                        color: #999999;
                    "
                    v-if="historyNorthData.length == 0"
                >
                    -暂无数据-
                </div>
            </section>
        </div>

        <div
            style="
                height: 3rem;
                text-align: center;
                line-height: 3rem;
                font-size: 14px;
                color: #999999;
            "
            v-if="notData && queryShow"
        >
            -暂无数据-
        </div>

        <div
            class="pop popFullWin"
            v-show="bxggcjtjHelpShow"
            @click.stop="bxggcjtjHelpShow = false"
        >
            <div
                class="pop-win question-deadline"
                :class="{ flyIn: bxggcjtjHelpShow }"
            >
                <p>
                    北向资金线即外资持股比 =
                    外资持股数除以该公司流通股数。北向资金线一定程度表明外资对股市的态度
                </p>
                <a
                    href="javascript:;"
                    class="pop-btn btn-cancel"
                    @click="bxggcjtjHelpShow = false"
                    >知道了</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { stockinfo, cgbl, hkcjmx, agcgbd } from "@/api/index.js";
import {
    chartInfo,
    getcgjg,
    getStkHolder,
    getStkHolderchg,
} from "@/api/xqDetail.js";
import { getUrlQuery } from "@/utils/handleUrl.js";

import { share } from "@/lib/dzh";
import wxshare from "@/assets/js/wxshare";

export default {
    name: "ggDetail",
    components: {},
    data() {
        return {
            notData: false,
            queryShow: false,
            stockCode: "", //股票代码
            version: "", //当前版本客户端
            stockInform: {
                stockName: "",
                stockCode: "",
                value: "",
                rate: "",
            },
            ccsz: "",
            cglt: "",
            cgsl: 0,
            dataTime: "",
            jml: "",
            lastYear: "",
            firstTime: "",
            cgbh: {
                value: "",
                max: "",
                min: "",
                latest: "",
            },
            chartData: [],
            chartStart: 80,
            chartEnd: 100,
            chartLength: 0,
            klineList: [],
            chartDomBox: null,
            organizationList: [], // 港资机构持股数据
            token: "", //云平台token
            userToken: "", //用户token
            historyNorthData: [], //成交榜数据
            cgbdData: [], //持股变动数据
            bxggcjtjHelpShow: false,
            codeType: "",
            websocket: null,
            websocketLink: null,
            echartsDomArr: [],
        };
    },
    filters: {
        formatePrefixData: function (v) {
            if (v == undefined || v == null || !v) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        // 处理金额
        process: function (value, fixed = 2, isZero, baseValue) {
            if (value) {
                if (!isNaN(value)) {
                    value = Number(value);
                    let len = parseInt(Math.abs(value), 10).toString().length;
                    if (baseValue === "元" || baseValue === "") {
                        value =
                            (len > 12 && value / 1000000000000) ||
                            (len > 8 && value / 100000000) ||
                            (len > 4 && value / 10000) ||
                            value;
                    } else if (baseValue === "万") {
                        value =
                            (len > 8 && value / 100000000) ||
                            (len > 4 && value / 10000) ||
                            value;
                    } else if (baseValue === "亿") {
                        value = (len > 4 && value / 10000) || value;
                    }
                    if (
                        !isZero ||
                        (!/^[-+]?\d*$/.test(value.toString()) &&
                            value.toString().split(".")[1].length > fixed)
                    ) {
                        value = value.toFixed(fixed);
                    }
                    if (baseValue === "元" || baseValue === "") {
                        value =
                            (len > 12 && value + "万亿") ||
                            (len > 8 && value + "亿") ||
                            (len > 4 && value + "万") ||
                            value + baseValue;
                    } else if (baseValue === "万") {
                        value =
                            (len > 8 && value + "万亿") ||
                            (len > 4 && value + "亿") ||
                            value + "万";
                    } else if (baseValue === "亿") {
                        value = (len > 4 && value + "万亿") || value + "亿";
                    }
                }
            } else if (value === 0) {
                value = "0.00";
            } else {
                value = "--";
            }
            return value;
        },
    },
    computed: {
        market() {
            return this.stockCode.slice(0, 2) === "SH" ? "沪" : "深";
        },
        datazoomStart(val) {
            return Math.round((this.chartStart / 100) * (this.chartLength - 1));
        },
        datazoomEnd(val) {
            return Math.round((this.chartEnd / 100) * (this.chartLength - 1));
        },
    },
    watch: {
        "cgbh.value"(val) {
            if (!this.chartDomBox) return;
            this.chartDomBox.setOption({
                graphic: [
                    {
                        id: "cgbh",
                        style: {
                            text: val !== 0 ? val + "万股" : "0股",
                            fill:
                                val > 0
                                    ? "#e30000"
                                    : val < 0
                                    ? "#4ca92a"
                                    : "#666",
                        },
                    },
                ],
            });
        },
        datazoomStart(val) {
            this.chartDomBox.setOption({
                graphic: [
                    {
                        id: "datazoomStart",
                        style: {
                            text: this.chartData.date[val],
                        },
                    },
                ],
            });
            this.setQuarter();
        },
        datazoomEnd(val) {
            this.chartDomBox.setOption({
                graphic: [
                    {
                        id: "datazoomEnd",
                        style: {
                            text: this.chartData.date[val],
                        },
                    },
                ],
            });
            this.setQuarter();
        },
    },
    created() {
        this.lastYear = this.getLastYear();
        this.stockCode = this.$route.params.code;
        this.userToken = getUrlQuery("token");
        this.version = getUrlQuery("version");
        this.stockInform.stockName = decodeURIComponent(
            this.$route.params.name
        );
        this.stockInform.stockCode = this.$route.params.code;
        wxshare.do(
            this.$route.fullPath,
            "http://static.yundzh.com/logo.png",
            "沪深港通"
        );
    },
    mounted: function () {
        this.codeType = this.$route.params.code.slice(0, 2);
        this.getYunToken();
        this.getCjb();
        if (
            this.$route.params.code.slice(0, 2) === "SH" ||
            this.$route.params.code.slice(0, 2) === "SZ"
        ) {
            this.getCgbl();
            this.getChartInfoData();
            this.getDzcgjg();
            this.getCgbd();
        }
        document.title = "沪深港通";
        share("沪深港通", this.$route.fullPath);
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }
    },
    methods: {
        // 跳转到个股分时
        gogufs: function () {
            window.location.href = `dzh_browser_url&goto=0&type=2970&code=${this.stockCode}&kind=1`;
        },
        // 跳转到搜索页
        goSearch: function () {
            this.$router.push("/search");
        },
        // 跳转到首页
        goHome: function () {
            this.$router.push("/");
        },
        goJiGaoDetail: function (item) {
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/jgdetail?code=" +
                item.particode +
                "&DZHSPECIAL=265&name=" +
                item.compname;
        },
        // 获取云平台token
        getYunToken: function () {
            let that = this;
            stockinfo().then((res) => {
                that.token = res.data.data.token;

                that.$nextTick(() => {
                    const data = res.data.data;
                    that.getStocksZf(data.url, data.token);
                });
            });
        },
        //获取当前个股加个以及涨幅
        getStocksZf: function (url, token) {
            let that = this;
            if (!this.websocket) {
                this.websocket = new WebSocket(`${url}/ws?token=${token}`);
                this.websocket.onopen = () => {
                    this.websocketSend();
                };
            } else {
                this.websocket.send(`/cancel?qid=1`);
                this.websocket.send(`/cancel?qid=2`);
                this.websocketSend();
            }
            this.websocket.onmessage = (evt) => {
                let fr = new FileReader();
                fr.readAsText(evt.data);
                fr.onload = () => {
                    let result = JSON.parse(fr.result);
                    if (result.Qid === "2") {
                        this.websocket.send(`/cancel?qid=2`);
                    }
                    let dynaList = result.Data.RepDataStkData;
                    if (dynaList) {
                        that.stockInform = {
                            stockName: dynaList[0].ZhongWenJianCheng,
                            stockCode: dynaList[0].Obj,
                            value: dynaList[0].ZuiXinJia,
                            rate: dynaList[0].ZhangFu,
                        };
                    } else if (this.klineList.length <= 0) {
                        result = result.Data.JsonTbl.data[0][0].data[0][1].data;
                        this.klineList = result;
                        if (this.chartDomBox) {
                            this.drawKL();
                        }
                    }
                };
            };
            this.websocket.onclose = () => {
                this.websocket.close();
                this.websocket = null;
                this.getYunToken();
            };
        },

        websocketSend() {
            this.websocket.send(
                `/stkdata?obj=${this.stockCode}&field=ZhongWenJianCheng,ZuiXinJia,ZhangFu&qid=1&sub=1`
            );
            this.websocket.send(
                `/quote/kline?obj=${this.stockCode}&field=ShiJian,KaiPanJia,ShouPanJia,ZuiDiJia,ZuiGaoJia&period=1day&start=0&count=300&begin_time=${this.lastYear}&qid=2&sub=1&split=1`
            );
        },

        // 获取持仓市值、流通比、净买量等数据
        getChartInfoData: function () {
            let that = this;
            chartInfo({ obj: this.stockCode, token: this.userToken }).then(
                (res) => {
                    if (res.data.err === 0) {
                        if (res.data.data.list.length > 0) {
                            let data = res.data.data.list[0];
                            that.ccsz = data.ChiGuShiZhi
                                ? data.ChiGuShiZhi
                                : "--";
                            that.cglt = data.ZhanLiuTongGuBiLi
                                ? data.ZhanLiuTongGuBiLi
                                : "--";
                            that.jml = data.ChiGuShiZhiBianHua
                                ? data.ChiGuShiZhiBianHua
                                : "--";
                            that.cgsl = data.ChiGuShuLiang
                                ? data.ChiGuShuLiang
                                : "--";
                            that.dataTime = res.data.data.time
                                ? res.data.data.time
                                : "--";
                        }
                    }
                }
            );
        },
        formatDate(timestamp, formatStr = "YYYY-MM-dd HH:mm:ss") {
            let date = timestamp ? new Date(timestamp * 1000) : new Date();
            const REGEX_FORMAT =
                /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
            const matches = {
                YYYY: date.getFullYear(),
                MM: this.padStart(date.getMonth() + 1, 2, "0"),
                dd: this.padStart(date.getDate(), 2, "0"),
                HH: this.padStart(date.getHours(), 2, "0"),
                mm: this.padStart(date.getMinutes(), 2, "0"),
                ss: this.padStart(date.getSeconds(), 2, "0"),
            };
            let str = formatStr;
            return str.replace(
                REGEX_FORMAT,
                (match, $1) => $1 || matches[match]
            );
        },
        padStart(string, length, pad) {
            const s = String(string);
            if (!s || s.length >= length) return string;
            return `${Array(length + 1 - s.length).join(pad)}${string}`;
        },
        getLastYear() {
            let that = this;
            let date = new Date();
            let year = date.getFullYear() - 1;
            let timestamp = date.setFullYear(year) / 1000;
            return that.formatDate(timestamp, "YYYYMMdd");
        },
        // 获取图表数据
        getCgbl() {
            cgbl({ obj: this.stockCode }).then((response) => {
                if (response.data.err == 0 && response.data.data != undefined) {
                    response = response.data.data[0];
                    if (response.Data) {
                        let data = response.Data;
                        if (data.length > 0) {
                            this.splitData(data);
                        }
                    } else {
                        this.notData = true;
                    }
                }
                this.queryShow = true;
            });
        },
        splitData(data) {
            let date = [];
            let ChiGuShuLiang = [];
            let ZhanLiuTongGuBiLi = [];
            let ShouPanJia = [];
            let ChiGuZhangFu = [];
            let ChiGuShuLiangBianHua = [];
            let seriesCGBH = [];
            let ZhanLiuTongGuBiLiBianHua = [];
            data = data.reverse();
            this.firstTime = data[0].ShiJian;
            this.getLastTime(data);
            this.cgbh.value = data[0].ChiGuShuLiangBianHua;
            this.cgbh.latest = data[0].ChiGuShuLiangBianHua;
            for (let item of data) {
                date.push(this.formatDate(item.ShiJian, "MM-dd"));
                ChiGuShuLiang.push(item.ChiGuShuLiang);
                ZhanLiuTongGuBiLi.push(item.ZhanLiuTongGuBiLi);
                ShouPanJia.push(item.ShouPanJia);
                ChiGuZhangFu.push(item.ChiGuZhangFu);
                ChiGuShuLiangBianHua.push(item.ChiGuShuLiangBianHua);
                seriesCGBH.push({
                    value: item.ChiGuShuLiangBianHua,
                    itemStyle: {
                        color:
                            item.ChiGuShuLiangBianHua > 0
                                ? "#f64950"
                                : "#27a642",
                    },
                });
                ZhanLiuTongGuBiLiBianHua.push(item.ZhanLiuTongGuBiLiBianHua);
            }
            this.cgbh.max = Math.max(...ChiGuShuLiangBianHua);
            this.cgbh.min = Math.min(...ChiGuShuLiangBianHua);
            this.chartData = {
                date,
                ChiGuShuLiang,
                ZhanLiuTongGuBiLi,
                ShouPanJia,
                ChiGuZhangFu,
                ChiGuShuLiangBianHua,
                seriesCGBH,
                ZhanLiuTongGuBiLiBianHua,
            };
            this.getechartData();
        },
        getechartData: function () {
            let that = this;
            stockinfo().then((res) => {
                const data = res.data.data;
                that.drawKL();
            });
        },
        getLastTime(data) {
            let timestamp = data[data.length - 1].ShiJian;
            this.lastTime = timestamp;
        },
        quarter(data) {
            // 最大值减最小值除以4，保留两位小数
            if (data.length > 0) {
                let max = Math.max(...data);
                let min = Math.min(...data);
                return Number((max - min) / 4);
            } else {
                return "";
            }
        },
        setQuarter() {
            let blQuarter = this.quarter(
                this.chartData.ZhanLiuTongGuBiLi.slice(
                    this.datazoomStart,
                    this.datazoomEnd + 1
                )
            );
            let spjQuarter = this.quarter(
                this.klineList
                    .slice(this.datazoomStart, this.datazoomEnd + 1)
                    .join(",")
                    .split(",")
            );
            this.chartDomBox.setOption({
                yAxis: [
                    {
                        interval: blQuarter,
                    },
                    {
                        interval: spjQuarter,
                    },
                ],
            });
        },
        // 渲染echarts图片
        drawKL: function () {
            let that = this;

            // 横坐标和系列数据只保留从第二个点开始的数据
            const xAxisData = that.chartData.date.slice(1); // 横坐标数据去掉第一个
            const ChiGuShuLiangData = that.chartData.ChiGuShuLiang.slice(1); // 持股量数据去掉第一个
            const ZhanLiuTongGuBiLiData = that.chartData.ZhanLiuTongGuBiLi.slice(1); // 持股比例数据去掉第一个

            var chartDom = document.getElementById("klineChart");
            var myChart = this.$echarts.init(chartDom);
            var option;
            option = {
                // grid 为直角坐标系内绘图网格，可以设置 x y x2 y2 等值。
                grid: {
                    containLabel: true, //防止坐标轴标签溢出
                    top: "12%",
                    right: "0%",
                    left: "0%",
                    bottom: "0%",
                },
                color: ["#286df7", "#fe7400"],
                // 提示框组件
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    borderWidth: 0,
                    textStyle: {
                        color: "#FFFFFF",
                        fontSize: 12,
                    },
                    axisPointer: {
                        type: "line",
                        lineStyle: {
                            type: "solid",
                        },
                    },
                    padding: [6, 4, 4, 6],
                    formatter: function (param) {
                        var result = `<p style="font-size: 12px;margin-bottom: 4px;color:#ffffff;">${param[0].axisValue}</p>`;
                        param.forEach((element, index) => {
                            if (index == 0) {
                                result += `<p style="margin-bottom: 4px;font-size: 12px;color:#ffffff;">持股量: ${element.value}万 </p>`;
                            } else if (index == 1) {
                                result += `<p style="margin-bottom: 4px;font-size: 12px;color:#ffffff;">持股比例: ${element.value}% </p>`;
                            }
                        });
                        // console.log('that.chartData.ZhanLiuTongGuBiLiBianHua',that.chartData.ZhanLiuTongGuBiLiBianHua)
                        // console.log('that.chartData.ZhanLiuTongGuBiLiBianHua',that.chartData.ChiGuShuLiang)
                        // result += `<p style="margin-bottom: 4px;font-size: 12px;color:#ffffff;">较上期: ${that.chartData.ZhanLiuTongGuBiLiBianHua[
                        //     param[0].dataIndex
                        // ].toFixed(2)}% </p>`;
                        
                        // 计算变化率（注意：使用后台的完整数据）
                        const currentIndex = param[0].dataIndex + 1; // 修正索引（跳过第一个点）
                        const currentVolume = that.chartData.ChiGuShuLiang[currentIndex];
                        const previousVolume = that.chartData.ChiGuShuLiang[currentIndex - 1];
                        const changeRate = ((currentVolume - previousVolume) / previousVolume * 100).toFixed(2);

                        result += `<p style="margin-bottom: 4px;font-size: 12px;color:#ffffff;">较上期: ${changeRate}% </p>`;

                        return result;
                    },
                },
                // 图例组件
                legend: {
                    show: true, //是否显示
                    type: "plain", // 图例的类型 'plain':普通图例  'scroll':可滚动翻页的图例
                    data: ["持股量", "持股比例"],
                    icon: "rect", //类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
                    top: "1%", //组件离容器的距离
                    left: "5%", // 组件离容器的距离
                    itemHeight: 8, // 图例高度
                    itemWidth: 8, // 图例宽度
                    textStyle: {
                        color: "#555555", // 文字的颜色。
                        fontSize: 12, // 文字的字体大小。
                    },
                },
                // 横轴组件
                xAxis: [
                    {
                        type: "category",
                        data: xAxisData,
                        axisLabel: {
                            // 不让最大值最小值隐藏
                            showMinLabel: true,
                            showMaxLabel: true,
                            interval: Math.ceil(that.chartData.date.length / 2),
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        scale: true, //自动适配y轴，不需要必须从0开始 或者选择下边这种设置最大最小值
                        position: "left", //坐标轴位置，移至右边
                        // min: function (value) {
                        //     return value.min;
                        // },
                        // max: function (value) {
                        //     return value.max;
                        // },
                        axisLabel: {
                            show: true,
                            // 设置 Y 轴的字体以及颜色
                            textStyle: {
                                color: "#999",
                                fontSize: "10",
                            },
                            // 使用 formatter 函数格式化标签
                            formatter: function (value) {
                                // 对值进行四舍五入取整
                                return Math.round(value);
                            },
                        },
                    },
                    {
                        type: "value",
                        show: false,
                        scale: true, //自动适配y轴，不需要必须从0开始 或者选择下边这种设置最大最小值
                    },
                ],

                series: [
                    {
                        name: "持股量",
                        type: "bar",
                        data: ChiGuShuLiangData,
                    },

                    {
                        name: "持股比例",
                        type: "line",
                        yAxisIndex: 1,
                        showSymbol: false,
                        data: ZhanLiuTongGuBiLiData, // 只显示从第二个点开始的数据
                    },
                ],
            };

            setTimeout(function () {
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            });
        },
        // 获取港资机构持股
        getDzcgjg: function () {
            let that = this;
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let type;
            if (isiOS) {
                type = "ios";
            } else if (isAndroid) {
                type = "android";
            }
            let obj = {
                httpdzh: that.version ? "dzh-" + type + "-" + that.version : "",
                stock: that.stockCode,
                token: that.userToken,
                pageNumber: 1,
                pageSize: 10,
            };
            getcgjg(obj).then((res) => {
                if (res.data.err === 0) {
                    let arr = res.data.data.list.map((item) => {
                        item.showMore = false;
                        return item;
                    });
                    that.organizationList = arr;
                }
            });
        },
        // 获取持股变动数据
        getCgbd: function () {
            let that = this;
            let obj = {
                stock: that.stockCode,
                page: 1,
                size: 5,
            };
            agcgbd(obj).then((res) => {
                if (res.data.err === 0) {
                    that.cgbdData = res.data.data.list;
                }
            });
        },
        // 获取成交榜数据
        getCjb: function () {
            let that = this;
            let obj = {
                stock: that.stockCode,
                page: 1,
                size: 5,
            };
            hkcjmx(obj).then((res) => {
                if (res.data.err === 0) {
                    that.historyNorthData = res.data.data.list;
                }
            });
        },
        goMore: function () {
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/ggMore?id=3&code=" +
                this.stockCode +
                "&DZHSPECIAL=265";
        },
        // 港资机构持股点击展开绘制echarts图标
        jiGouEchartsShow: function (index, item) {
            let that = this;
            that.organizationList[index].showMore =
                !that.organizationList[index].showMore;
            that.$nextTick(() => {
                if (that.organizationList[index].showMore) {
                    that.getHolderchg(that.stockCode, item.particode, index);
                }
            });
        },
        // 请求持股变化历史图
        getHolderchg: function (stkId, jiGouId, index) {
            let that = this;
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let type;
            if (isiOS) {
                type = "ios";
            } else if (isAndroid) {
                type = "android";
            }
            let obj = {
                httpdzh: that.version ? "dzh-" + type + "-" + that.version : "",
                stock: stkId,
                token: that.userToken,
                qid: +new Date(),
                particode: jiGouId,
            };
            getStkHolderchg(obj).then((res) => {
                if (res.data.err === 0) {
                    if (res.data.data) {
                        let arr = res.data.data.reverse();
                        that.drawJiGouChart(arr, index);
                    }
                }
            });
        },
        // 绘制图表
        drawJiGouChart: function (arr, index) {
            let that = this;
            if (that.organizationList[index].showMore) {
                if (!that.echartsDomArr[index]) {
                    let myChart = that.$echarts.init(
                        document.querySelectorAll(".chart-tr")[index]
                    );
                    that.echartsDomArr[index] = myChart;
                }
                let dateArr = arr.map((item) => {
                    return (
                        item.tradedate.substr(0, 4) +
                        "-" +
                        item.tradedate.substr(4, 2) +
                        "-" +
                        item.tradedate.substr(6, 2)
                    );
                });
                let showArr = arr.map((item) => {
                    return item.cbuyamt;
                });
                var option;
                option = {
                    xAxis: {
                        type: "category",
                        data: dateArr,
                        show: true,
                        axisLine: {
                            lineStyle: {
                                color: "#f5f5f5", // 坐标轴线线的颜色
                            },
                        },
                        axisLabel: {
                            color: "#999",
                            fontSize: 10,
                            margin: 0,
                            interval: 10000,
                            showMinLabel: true,
                            showMaxLabel: true,
                            formatter: function (value) {
                                //文本格式化
                                if (value === dateArr[0]) {
                                    return "{right|" + value + "}";
                                } else if (
                                    value === dateArr[dateArr.length - 1]
                                ) {
                                    return "{left|" + value + "}";
                                } else {
                                    return "{center|" + value + "}";
                                }
                            },
                            rich: {
                                right: {
                                    width: 50,
                                    fontSize: 10,
                                    align: "left",
                                    padding: [0, 0, 0, 50],
                                },
                                left: {
                                    width: 50,
                                    fontSize: 10,
                                    align: "left",
                                    padding: [0, 60, 0, 0],
                                },
                                center: {
                                    fontSize: 10,
                                    align: "left",
                                },
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    grid: {
                        top: "2",
                        bottom: "10",
                        left: "0",
                        right: "0",
                        show: false,
                    },
                    yAxis: {
                        type: "value",
                        show: false,
                    },
                    series: [
                        {
                            data: showArr,
                            type: "bar",
                            itemStyle: {
                                color: function (params) {
                                    return params.value >= 0
                                        ? "#e30000"
                                        : "#4ca92a";
                                },
                            },
                        },
                    ],
                };
                option && that.echartsDomArr[index].setOption(option);

                window.addEventListener("resize", function () {
                    that.echartsDomArr[index].resize();
                });
            }
        },
    },
    beforeDestroy() {
        this.echartsDomArr.forEach((item) => {
            if (item) {
                item.dispose();
            }
        });
    },
};
</script>
